<div class="av-full-card-summary-item">
    <ng-content></ng-content>
</div>